<template>
    <v-row no-gutters>
        <v-col cols="12" lg="12">
            <div id="myDiv">
                <div class="colouredCard" color="#f2f2f2">
                    <v-banner double-line>
                        <span class="title">Summary</span>
                        <template v-slot:actions>
                        <v-btn small v-if="accessFlag && ticketingActivity.status !== 'closed'" @click="goToAction" color="primary" outlined
                            class="text-capitalize mb-2">
                            <v-icon left>mdi-chevron-down</v-icon>
                            Action Ticket
                        </v-btn>
                        </template>
                    </v-banner>
                    <div class="commentsSroll" v-if="historyLogData.length > 0">
                        <v-card class="mb-4 mx-4 my-2" rounded="lg" elevation="2" v-for="(eachData,index) in historyLogData"
                        :key="`history_log_${index}`">
                        <span class="caption"
                            style="right:15px; top:10px; position:absolute;">({{ eachData.Currenttime }})
                        </span>
                        <div class="overflowed">
                            <v-card-title>
                            Name
                            <span class="font-weight-regular">:
                                {{ eachData.createdby }}</span>
                            </v-card-title>
                            <v-card-subtitle class="font-weight-medium black--text ">
                            Attachment:
                            <span v-if="eachData.attachment && eachData.attachment.data.length > 0">
                                <v-btn color="primary" outlined class="px-2 ml-1 ma-1" min-width="0" small
                                v-for="(url, index) in eachData.attachment.data" :key="`attached_file_${index}`"
                                @click="downloadFile(url)">
                                <v-icon small>mdi-download</v-icon>
                                </v-btn>
                            </span>
                            <span v-else class="font-weight-regular">Not Available</span> <br />
                            <span>
                                By:
                            </span><span
                                class="font-weight-regular">{{ eachData && eachData.lastmodifiedby ? eachData.lastmodifiedby : '-' }}</span>
                            <br />
                            <span>
                                Comment:
                            </span>
                            <div class="font-weight-regular"
                                v-html="(eachData.coments && eachData.coments !== 'null') ? eachData.coments : '-'">
                            </div>
                            </v-card-subtitle>
                            <div style="text-align:right">
                            <span class="font-weight-regular pr-2"
                                style="font-size:85%">({{ eachData.createdAt || '-' }})</span>
                            </div>
                        </div>
                        </v-card>
                    </div>
                </div>
                <v-divider class="my-2"></v-divider>
                    <v-card outlined id="actionTicketID"
                        v-if="ticketingActivity.status !== 'closed' && accessFlag">
                        <v-banner dauble-line>
                        <span class="title">Action</span>
                        </v-banner>
                        <div class="mt-4">
                        <form autocomplete="off" @submit.prevent="onSubmit">
                            <v-row>
                            <v-col cols="12" md="12" class="px-8 py-0">
                              <label class="font-weight-medium"> Comment <span
                                  class="error--text">*</span> </label>
                              <ckeditor
                                placeholder="Add Comment"
                                required
                                v-model="description"
                                ref="ckeditorRef"
                              >
                              </ckeditor>
                            </v-col>
                            <v-col cols="12" md="12" class="px-8 py-0">
                                <label class="font-weight-medium">Upload File </label>
                                <v-file-input
                                  :messages="['(max file size allowed 50MB)']"
                                  class="my-0 py-1"
                                  v-model="dropFiles"
                                  @change="onFilechange()"
                                  show-size
                                  placeholder="Click to Upload"
                                  outlined
                                  :disabled="ticketingActivity.status == 'closed'"
                                  multiple
                                  prepend-icon=""
                                  prepend-inner-icon="mdi-paperclip"
                                >
                                </v-file-input>
                                <div class="tags" v-if="dropFiles && dropFiles.length > 0 && sizeInMB < 50">
                                <div v-for="(file, index) in dropFiles" :key="index">
                                <span class="tag is-primary" id="chiptxt">
                                    {{ file.name }}
                                </span>
                                <button class="delete is-small" type="button"
                                    @click="deleteDropFile(index)"></button>
                                </div>
                                </div>
                            </v-col>
                            <v-col cols="12" md="12">
                                <v-card-actions class="d-flex justify-end pl-0">
                                  <v-btn :disabled="ticketingActivity.status == 'closed'" bottom right
                                      elevation="1" color="primary" type="submit">
                                      <v-icon left> mdi-content-save </v-icon>
                                      Update
                                  </v-btn>
                                </v-card-actions>
                            </v-col>
                            </v-row>
                        </form>
                        </div>
                    </v-card>
            </div>
        </v-col>
</v-row>
</template>
<script>
import constants from '@/utils/constants'
import moment from 'moment'
// import _ from 'lodash'
export default {
  name: 'ticketSummaryComponent',
  props: {
    ticketID: {
      type: [String, Number],
      default: null
    },
    ticketObj: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      ticketingActivity: [],
      historyLogData: [],
      accessFlag: true,
      description: '',
      dropFiles: []
    }
  },
  watch: {
    ticketObj: {
      handler: function (newVal) {
        this.getTicketSummary()
      },
      deep: true
    }
  },
  created () {
    this.getTicketSummary()
  },
  methods: {
    getTicketSummary: async function () {
      try {
        let payload = {}
        payload.ticketID = parseInt(this.ticketID)
        const res = await http.post(`${constants.API_URL}/api/sbTicketing/getTicketHistory`, payload)
        if (res.status === 200) {
          if (res.data.status) {
            this.historyLogData = res.data.data
            this.historyLogData.forEach(item => {
              item.Currenttime = moment(item.lastmodifieddate, 'YYYY-MM-DDThh:mm:ss').fromNow()
              item.createdAt = moment(item.lastmodifieddate, 'YYYY-MM-DDThh:mm:ss').format('MMMM Do YYYY, LTS')
            })
          }
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      }
    },
    deleteDropFile (index) {
      if (this.dropFiles) {
        this.dropFiles.splice(index, 1)
      }
    },
    onFilechange: function () {
      if (this.dropFiles && this.dropFiles.length > 0) {
        let fileSize = null
        this.dropFiles.filter(s => {
          fileSize = s.size
          return s.size
        })

        this.sizeInMB = (fileSize / (1024 * 1024)).toFixed(2)
      }

      let Sizes = 0
      for (let file of this.dropFiles) {
        Sizes = Sizes + file.size
      }

      let totalSize = (Sizes / (1024 * 1024)).toFixed(2)

      if (this.sizeInMB && totalSize > 50) {
        this.dropFiles = []
        this.$dialog.error({
          title: 'Error',
          text: 'File should be less than or equal to 50 MB'
        })
      }

      let fileName = null

      this.dropFiles.filter(n => {
        fileName = n.name
        return n.name
      })
      if (/^[a-zA-Z0-9- _.]*$/.test(fileName) === false) {
        this.dropFiles = []
        this.$dialog.error({
          title: 'Error',
          text: 'File name should not contain any special symbol'
        })
      }
    },
    onSubmit: async function () {
      this.$dialog.confirm({
        title: 'Do you want to update the ticket?',
        text: 'Are you sure you want to <b>update</b> ticket?',
        actions: {
          false: {
            text: 'No',
            handle: () => {
              this.$nextTick(() => {
                return false
              })
            }
          },
          true: {
            color: 'success',
            text: 'Yes',
            handle: async () => {
              try {
                console.log(this.ticketObj)
                let formData = new FormData()
                formData.append('issueid', parseInt(this.ticketID))
                formData.append('issuecode', this.ticketObj.issuecode)
                formData.append('issuename', this.ticketObj.issuename)
                formData.append('description', this.ticketObj.scenario)
                formData.append('priority', this.ticketObj.priority)
                formData.append('allotedto', parseInt(this.ticketObj.assignedtoid))
                formData.append('lastmodifiedby', this.ticketObj.lastmodifiedby)
                formData.append('queryRelatedTo', parseInt(this.ticketObj.queryrelatedtodeptid))
                formData.append('queryType', parseInt(this.ticketObj.querytypeid))
                formData.append('comment', this.description)
                formData.append('status', this.ticketObj.status)
                formData.append('franchiseeName', this.ticketObj.vendorcode)
                if (this.dropFiles.length > 0) {
                  this.dropFiles.forEach(file => {
                    formData.append('file', file)
                  })
                }
                let res = await http.post(`${constants.API_URL}/api/sbTicketing/updateTicket`, formData)
                if (res.status === 200) {
                  if (res.data.status) {
                    this.$dialog.info({
                      text: res.data.msg,
                      title: 'Success'
                    })
                    this.description = ''
                    this.dropFiles = []
                    await this.getTicketSummary()
                  }
                }
              } catch (e) {
                const errorMessage = (e && e.response && e.response.data.message) || e.message
                return this.$dialog.error({
                  text: errorMessage,
                  title: 'Error'
                })
              }
            }
          }
        }
      })
    },
    goToAction: function () {
      document.getElementById('actionTicketID').scrollIntoView()
    },
    downloadFile: function (url) {
      this.$emit('download', url)
    }
  }
}
</script>
<style>
.colouredCard{border:solid 1px #e4e4e4;}
</style>
